// extracted by mini-css-extract-plugin
module.exports = {"container":"TABody_container__2rUzi"};